var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tv-template-preview',{key:_vm.menuPageAsString,ref:"current-menu-preview",class:[_vm.elevationClass],style:({
      'max-width': _vm.previewMaxWidth + 'px',
      'max-height': _vm.previewMaxHeight + 'px',
    }),attrs:{"fake-player-progress":false,"html-overlay":_vm.menuPage.menu_template.html_overlay,"width":_vm.tvdecoder.tvformat.width,"height":_vm.tvdecoder.tvformat.height,"max-width":_vm.previewMaxWidth,"max-height":_vm.previewMaxHeight,"duration":_vm.menuPage.menu_template.duration,"hide-restart-button":true,"hide-player-controls":true,"onload-callback":function () { return _vm.populateCurrentMenuPagePreviewIframeWithOverlayData(_vm.menuPage); }}})}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/DecoderDetail/TvDecoderMenuPagePreview.vue?vue&type=template&id=27647ec9&scoped=true&
// module id = 2302
// module chunks = 5